import { AddProvidedUserInfoToCreditStudyCommand } from '../../../domain/commands/add-user-info-to-credit-study.command';
import { AcademicBackground } from '../../../domain/models/enums/academic-background';
import { ContractType } from '../../../domain/models/enums/contract-types';
import { EmploymentSituationName } from '../../../domain/models/enums/employment-situation-name';
import { MaritalStatus } from '../../../domain/models/enums/marital-status';

export type AddProvidedUserInfoToCreditStudyResponseDto = {
  addUserInfoToCreditStudy: {
    value: string;
  };
};

export type InitializeCreditStudyResponseDto = {
  initializeCreditStudy: {
    value: string;
  };
};

type AddProvidedUserInfoToCreditStudyInput = {
  creditStudy: string;
  academicBackground: AcademicBackground;
  employmentSituation: EmploymentSituationName;
  declaredIncoming: number;
  maritalStatus: MaritalStatus;
  declaresRent: boolean;
  hasDependents: boolean;
  dateOfBirth: number;
  employerName?: string;
  contractType?: ContractType;
  incomingSource?: string;
  numberPayRentsInAdvance?: number;
};

export type AddProvidedUserInfoToCreditStudyDto = {
  input: AddProvidedUserInfoToCreditStudyInput;
};

export const mapInitializeCreditStudyCommandToDto = (
  command: AddProvidedUserInfoToCreditStudyCommand
): AddProvidedUserInfoToCreditStudyDto => {
  return {
    input: {
      creditStudy: command.creditStudy.value,
      academicBackground: command.academicBackground,
      employmentSituation: command.employmentSituation,
      employerName: command.employerName?.value,
      contractType: command.contractType,
      incomingSource: command.incomingSource?.value,
      declaredIncoming: command.declaredIncoming.value,
      maritalStatus: command.maritalStatus,
      declaresRent: command.declaresRent.value,
      hasDependents: command.hasDependents.value,
      dateOfBirth: command.dateOfBirth.value,
      numberPayRentsInAdvance: command.numberPayRentsInAdvance?.value,
    },
  };
};
